import { Edit, Underline } from 'lucide-react'
import { Button } from '@components/ui/button'
import { Checkbox } from '@components/ui/checkbox'
import { cn } from '@/utils'
import type { TextStylesPreview } from '../hooks/use-text-styles-preview'
import { SectionHeading } from './section-heading'

interface TextStylesSectionProps {
  preview: TextStylesPreview
  disabled: boolean
}

/** Text Styles: the group heading and the Heading Large preview card. Renders siblings (a
 *  Fragment) so each stays a direct child of the panel's spaced column. */
export function TextStylesSection({ preview, disabled }: TextStylesSectionProps) {
  const { headingLarge, setHeadingLarge, headingFontFamily, headingFontWeight } = preview
  const { selectedText, setSelectedText } = preview

  return (
    <>
      {/* Text Styles Section */}
      <div>
        <SectionHeading>Text Styles</SectionHeading>
      </div>

      {/* Heading Large Section */}
      <div className="bg-card border border-border rounded-md p-3 mt-2">
        <div className="flex items-center gap-2">
          <Checkbox
            id="heading-large"
            checked={headingLarge}
            disabled={disabled}
            onCheckedChange={(checked) => {
              if (disabled) return
              setHeadingLarge(!!checked)
            }}
          />
          <label
            htmlFor="heading-large"
            className="text-sm font-medium text-foreground leading-normal"
          >
            Heading Large
          </label>
          <Button variant="ghost" size="icon-xs" className="ml-auto" disabled={disabled}>
            <Edit className="h-3 w-3" />
          </Button>
        </div>
        <div className="mt-2 space-y-2">
          <div className="text-sm text-foreground flex items-center flex-wrap">
            <span
              className={cn(
                'cursor-pointer text-muted-foreground hover:text-foreground transition-colors px-1 py-0.5 rounded',
                selectedText === 'fontFamily' && 'bg-accent text-accent-foreground'
              )}
              onClick={() => setSelectedText(selectedText === 'fontFamily' ? null : 'fontFamily')}
            >
              {headingFontFamily}
            </span>
            <span className="mx-2 shrink-0"></span>
            <span
              className={cn(
                'cursor-pointer text-muted-foreground hover:text-foreground transition-colors px-1 py-0.5 rounded',
                selectedText === 'fontWeight' && 'bg-accent text-accent-foreground'
              )}
              onClick={() => setSelectedText(selectedText === 'fontWeight' ? null : 'fontWeight')}
            >
              {headingFontWeight}
            </span>
          </div>
          <div className="flex gap-1 items-center justify-between">
            <div className="flex gap-1">
              <Button
                variant="ghost"
                size="xs"
                className="bg-accent text-accent-foreground"
                disabled={disabled}
              >
                32pt
              </Button>
              <Button
                variant="ghost"
                size="xs"
                className="text-muted-foreground hover:text-foreground"
                disabled={disabled}
              >
                Auto
              </Button>
            </div>
            <Button variant="ghost" size="icon-sm" aria-label="Underline" disabled={disabled}>
              <Underline className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
